import React from "react";
import Modal from "..";
import * as S from "./userInfoEditModal.style";
import { Button } from "../../../atoms/Buttons";

type UserInfoEditModalType = {
  onModalCloseHanlder: () => void;
};

const UserInfoEditModal = ({ onModalCloseHanlder }: UserInfoEditModalType) => {
  return (
    <Modal title="내 정보 변경 완료" titlePosition="center" size="md">
      <S.UserInfoEditModalLayout>
        <p> 내 정보 변경이 완료되었습니다. </p>
        <Button
          type="button"
          size="full"
          color="primary"
          label="닫기"
          onClick={onModalCloseHanlder}
        />
      </S.UserInfoEditModalLayout>
    </Modal>
  );
};

export default UserInfoEditModal;
